Vue.asyncComponent('cms-dashboard-shortcut', {
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: 'link',
        },
        href: {
            type: String,
            default: '',
        },
        target: {
            type: String,
            default: '_self',
        },
    },
    computed: {
        /**
         * Component tag.
         */
        componentTag() {
            return this.href ? 'a' : 'div';
        },
        /**
         * Shortcut attributes.
         */
        shortcutAttributes() {
            return this.href
                ? {
                    href: this.href,
                    target: this.target || '_self',
                }
                : {};
        },
    },
}, 'cms/dashboard/live/cms-dashboard-shortcut.html');
